export default {"src":"/_next/static/media/confetti-banner.12020b56.svg","height":191,"width":375};